import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    // Après assignation dynamique des <source>, load() ne réapplique pas toujours l’autoplay :
    // forcer muted/loop/playsInline (politique navigateur) puis play() au canplay.
    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.loop = true;
    videoElement.playsInline = true;
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('playsinline', '');

    let playStarted = false;
    const tryPlay = () => {
      if (playStarted) return;
      playStarted = true;
      videoElement.play().catch(() => {});
    };

    videoElement.addEventListener('canplay', tryPlay, { once: true });
    videoElement.load();
    if (videoElement.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
      tryPlay();
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
